import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';

@Component({
    selector: 'app-db-backup-details',
    templateUrl: './db-backup-details.component.html',
    styleUrls: ['./db-backup-details.component.scss'],
    standalone: false
})
export class DbBackupDetailsComponent implements OnInit {

  fromFields: any;
  toFields: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public matdialogRef: MatDialogRef<DbBackupDetailsComponent>) {
  }

  ngOnInit(): void {
    this.fromFields = [
      {
        name: translate('DB_DETAILS.SERVER_NAME'),
        key: 'serverName',
      },
      {
        name: translate('DB_DETAILS.DATABASE_NAME'),
        key: 'databaseName',
      },
      {
        name: translate('DB_DETAILS.SUBSCRIPTION_ID'),
        key: 'subscriptionId',
      },
      {
        name: translate('DB_DETAILS.RESOURCE_GROUP'),
        key: 'resourceGroup',
      }
    ]
    this.toFields = [
      {
        name: translate('DB_DETAILS.SERVER_NAME'),
        key: 'serverName',
      },
      {
        name: translate('DB_DETAILS.DATABASE_NAME'),
        key: 'databaseName',
      },
      {
        name: translate('DB_DETAILS.SUBSCRIPTION_ID'),
        key: 'subscriptionId',
      },
      {
        name: translate('DB_DETAILS.RESOURCE_GROUP'),
        key: 'resourceGroup',
      },
       {
        name: translate('DB_DETAILS.STORAGE_NAME'),
        key: 'storageName',
      },
      {
        name: translate('DB_DETAILS.CONTAINER_NAME'),
        key: 'containerName',
      },
      {
        name: translate('DB_DETAILS.FILE_NAME'),
        key: 'fileName',
      },
      {
        name: translate('DB_DETAILS.SOLUTION_VERSION'),
        key: 'solutionVersion',
      },
      {
        name: translate('DB_DETAILS.RELEASE_VERSION'),
        key: 'releaseVersion',
      }
    ]
    if (this.data.backupType === 'snapshot') {
      const keysToRemove = ['storageName', 'fileName', 'containerName'];
      this.toFields = this.toFields.filter(field => !keysToRemove.includes(field.key));
    }
    if (this.data.from?.type?.toLowerCase()?.includes('postgresql')) {
      const keysToRemove = ['databaseName'];
      this.toFields = this.toFields.filter(field => !keysToRemove.includes(field.key));
      this.fromFields = this.fromFields.filter(field => !keysToRemove.includes(field.key));
    }
  }
}
